import { useCallback } from "react";
import { UtilityService } from "../services/UtilityService";

export const useThemeManagement = () => {
  const handleThemeChange = useCallback((newTheme) => {
    // If no theme provided, read from localStorage and toggle
    if (!newTheme) {
      const currentTheme = localStorage.getItem("theme") || "light";
      newTheme = currentTheme === "dark" ? "light" : "dark";
    }

    // Update localStorage first
    localStorage.setItem("theme", newTheme);

    // Then dispatch to Redux
    UtilityService.updateThemeMode(newTheme);
  }, []);

  return { handleThemeChange };
};
